import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { communications, types } from '../../../constants/communications';
import CommunicationService from '../../../services/components/Communication';
import Notifications from '../../Notifications';
import Session from '../../../utils/session';

const CommunicationsProvider = ({ isCircle, isAuth }) => {
  const { pathname } = useLocation();

  const onAnalize = useCallback(
    ({ paths, variable, acceptCircle, fromDate, toDate, each, type }) => {
      if (type === types.UNNAUTHENTICATE_VALIDATION) {
        // We use Session because it is before redux global state and we fix diley problem
        return (
          !Session.getAuth() &&
          CommunicationService.checkPathnameConfig(pathname, paths) &&
          CommunicationService.showByDate(fromDate, toDate)
        );
      }

      if (type === types.DAYS_VALIDATION) {
        return (
          isAuth &&
          CommunicationService.checkPathnameConfig(pathname, paths) &&
          CommunicationService.checkCircleConfig(acceptCircle, isCircle) &&
          CommunicationService.checkTypeDate(variable, fromDate, toDate, each)
        );
      }

      if (type === types.BOOLEAN_VALIDATION) {
        return (
          isAuth &&
          CommunicationService.checkPathnameConfig(pathname, paths) &&
          CommunicationService.checkCircleConfig(acceptCircle, isCircle) &&
          CommunicationService.checkTypeBoolean(variable, toDate)
        );
      }
    },
    [pathname, isCircle, isAuth],
  );

  const onAccept = ({ variable, type }) => {
    if (variable) {
      CommunicationService.saveVariable(
        variable,
        type === types.DAYS_VALIDATION ? new Date() : true,
      );
    }
  };

  return <Notifications onAnalize={onAnalize} onAccept={onAccept} config={communications} />;
};

const mapStateToProps = (state) => {
  return {
    isCircle: state.auth?.authData?.isCircle,
    isAuth: state.auth.authData && !!Object.keys(state.auth.authData).length,
  };
};

export default connect(mapStateToProps, null)(CommunicationsProvider);
